import dotProp from 'dot-prop-immutable'
import {
  TOGGLE_MODAL_FRAMES,
  TOGGLE_NAVIGATION_FRAMES,
  TOGGLE_NAVIGATION_PHOTOS,
  TOGGLE_NAVIGATION_PRODUCTS,
  TOGGLE_NAVIGATION_WALLS,
  TOGGLE_SIDEBAR,
} from '../constants/sidebarActions'

const initialState = {
  isClosed: false,
  photos: {
    isToggled: false,
  },
  walls: {
    isToggled: false,
  },
  products: {
    isToggled: false,
  },
  frames: {
    isToggled: false,
    modal: {
      isOpen: false,
      src: '',
    },
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return dotProp.set(state, 'isClosed', !state.isClosed)
    case TOGGLE_NAVIGATION_PHOTOS:
      state = dotProp.set(state, 'photos.isToggled', !state.photos.isToggled)
      state = dotProp.set(state, 'walls.isToggled', false)
      state = dotProp.set(state, 'products.isToggled', false)
      state = dotProp.set(state, 'frames.isToggled', false)

      return state
    case TOGGLE_NAVIGATION_WALLS:
      state = dotProp.set(state, 'photos.isToggled', false)
      state = dotProp.set(state, 'walls.isToggled', !state.walls.isToggled)
      state = dotProp.set(state, 'products.isToggled', false)
      state = dotProp.set(state, 'frames.isToggled', false)

      return state
    case TOGGLE_NAVIGATION_PRODUCTS:
      state = dotProp.set(state, 'photos.isToggled', false)
      state = dotProp.set(state, 'walls.isToggled', false)
      state = dotProp.set(state, 'products.isToggled', !state.products.isToggled)
      state = dotProp.set(state, 'frames.isToggled', false)

      return state
    case TOGGLE_NAVIGATION_FRAMES:
      state = dotProp.set(state, 'photos.isToggled', false)
      state = dotProp.set(state, 'walls.isToggled', false)
      state = dotProp.set(state, 'products.isToggled', false)
      state = dotProp.set(state, 'frames.isToggled', !state.frames.isToggled)

      return state
    case TOGGLE_MODAL_FRAMES:
      state = dotProp.set(state, 'frames.modal.isOpen', !dotProp.get(state, 'frames.modal.isOpen', false))
      state = dotProp.set(state, 'frames.modal.src', action.src)

      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sidebar.js